const PRODUCTION_BASE_URL = 'https://www.elitesportstours.com';

/**
 * Generates a canonical URL for SEO purposes.
 * Returns the production base URL with the given path.
 * Optionally includes query parameters for pages that require them (e.g., concert pages with parentId).
 * @param pathname - The pathname of the page (e.g., '/events/nba')
 * @param queryParams - Optional query parameters to include (e.g., { parentId: '54' })
 * @returns The canonical URL string
 */
export const getCanonicalUrl = (
  pathname: string,
  queryParams?: Record<string, string>
): string => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const url = `${PRODUCTION_BASE_URL}${normalizedPath}`;

  if (queryParams && Object.keys(queryParams).length > 0) {
    const search = new URLSearchParams(queryParams).toString();
    return `${url}?${search}`;
  }

  return url;
};
